import {useBAData} from '../../context'
import {isNil, isEmpty} from 'ramda'

export const DataSetSelect = () => {
    const {setActiveBAData, baData} = useBAData()
    const handleClick = (item) => {
        console.log(item.setName)
        console.log({baData})
        setActiveBAData(item)
    }
    const dataIsValid = (data) => {
        return !isNil(data) && !isEmpty(data) && data.length > 0
    }
    return (
        <center>
            <div><b>Select Team Type</b></div>
            <div className="is-flex is-justify-content-center is-align-items-center is-flex-direction-row is-flex-wrap-wrap" style={{marginBottom: "1rem"}}>
                {dataIsValid(baData) && baData.map((item, i) => <DatasetButton item={item} key={"Dataset Button" + i} handleClick={handleClick} />)}
            </div>
        </center>
    )
}

const DatasetButton = ({item, handleClick}) => {
    const {activeBADataSetName} = useBAData()
  return (
    <div>
      <button className={`button is-small ${activeBADataSetName === item.setName && "is-danger"}`} onClick={() => handleClick(item)}>{item.setName}</button>
    </div>
  );
};